var render, staticRenderFns
import script from "./extsubmenu.vue?vue&type=script&lang=js"
export * from "./extsubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5425d6cd')) {
      api.createRecord('5425d6cd', component.options)
    } else {
      api.reload('5425d6cd', component.options)
    }
    
  }
}
component.options.__file = "src/element-ui/ext/extsubmenu.vue"
export default component.exports